import { render } from "./ConversionByCourse.vue?vue&type=template&id=2280fa2a"
import script from "./ConversionByCourse.vue?vue&type=script&lang=js"
export * from "./ConversionByCourse.vue?vue&type=script&lang=js"

import "./ConversionByCourse.vue?vue&type=style&index=0&id=2280fa2a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__